import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Payment/dues.css';
import { useUser } from '../context/UserContext';
import { hasPrivilege } from '../utils/hasPrivilege';
import { CSVLink } from 'react-csv';
import axios from 'axios';
import Select from 'react-select';
import SettlePaymentModal from './SettlePayment';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';

const DuesList = () => {
  const token = localStorage.getItem('auth-token');
  const { userData } = useUser();
  const [searchTerm, setSearchTerm] = useState('');
  const [dueWithFilter, setDueWithFilter] = useState(null);
  const [playerFilter, setPlayerFilter] = useState(null);
  const [batchFilter, setBatchFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const { selectedCenter, setSelectedCenter } = useUser();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedDueId, setSelectedDueId] = useState(null);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [dues, setDues] = useState([]);
  const today = new Date();
  const tenDaysAgo = new Date(today);
  tenDaysAgo.setDate(today.getDate() - 30);
  const [fromDateFilter, setFromDateFilter] = useState(tenDaysAgo.toISOString().split('T')[0]);
  const [toDateFilter, setToDateFilter] = useState(today.toISOString().split('T')[0]);


  const fetchDues = async () => {
    if (!selectedCenter) {
      return;
    }
    setError('');
    setLoading(true);
    try {
      const apiUrl = `${process.env.REACT_APP_API_ACADEMY_SETTLE_PAYMENT_DUE}/${selectedCenter}/payment-dues`;
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      };

      const payload = {
        dueWithIn: null,
        fromDate: fromDateFilter,
        toDate: toDateFilter,
      };

      const response = await axios.post(apiUrl, payload, { headers });
      const result = response.data;

      if (result.success) {
        const parentMobileNumberMap = result.data.parentMobileNumber;
        const transformedDues = result.data.dueList.map((due) => ({
          id: due.id,
          player: due.player?.user?.name || '-',
          mobile: due.player?.user?.mobile_number || '-',
          parentMobile: parentMobileNumberMap?.[due.player?.id] || '-',
          batch: due?.batch?.name,
          amount: due?.amount - (due?.paidAmount || 0),
          dueOn: due?.dueFrom,
          startDate: due?.dueFrom,
          endDate: due?.dueEndDate,
          term: `${due?.dueFrom?.split('T')[0] || '-'} - ${due?.dueEndDate?.split('T')[0] || '-'}`,
          totalDues: response.data.sumOfDues,
        }));


        setDues(transformedDues);
        setError('');
      } else {
        setError('Failed to load data: ' + result.success_message);
      }
    } catch (error) {
      setError('Error fetching data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDues();
  }, [selectedCenter, fromDateFilter, toDateFilter]);

  const headers = [
    { label: "Player", key: "player" },
    { label: "Mobile", key: "mobile" },
    { label: "Parent Mobile", key: "parentMobile" },
    { label: "Batch", key: "batch" },
    { label: "Amount", key: "amount" },
    { label: "Due On", key: "dueOn" },
    { label: "Term", key: "term" },
  ];

  const [dropdownVisible, setDropdownVisible] = useState(null);
  const navigate = useNavigate();

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const toggleDropdown = (id) => {
    setDropdownVisible((prev) => (prev === id ? null : id));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSettlePayment = (dueId) => {
    setSelectedDueId(dueId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDueId(null);
  };


  const playersList = [...new Set(dues.map((due) => due.player))];
  const batchesList = [...new Set(dues.map((due) => due.batch))];

  const handleDueWithFilterChange = (selectedOption) => {
    setDueWithFilter(selectedOption);
  };

  const handlePlayerFilterChange = (selectedOption) => {
    setPlayerFilter(selectedOption);
  };

  const handleBatchFilterChange = (selectedOption) => {
    setBatchFilter(selectedOption);
  };

  const handleFromDateChange = (e) => {
    setFromDateFilter(e.target.value);
  };

  const handleToDateChange = (e) => {
    setToDateFilter(e.target.value);
  };

  const dueWithOptions = [
    { value: 'Week', label: 'Week' },
    { value: 'Month', label: 'Month' },
    { value: 'Year', label: 'Year' },
  ];

  const playerOptions = playersList.map(player => ({
    value: player,
    label: player,
  }));

  const batchOptions = batchesList.map(batch => ({
    value: batch,
    label: batch,
  }));

  const filteredDues = dues.filter((due) => {

    const matchesPlayer = !playerFilter || due.player === playerFilter.value;
    const matchesBatch = !batchFilter || due.batch === batchFilter.value;
    const matchesFromDate = !fromDateFilter || new Date(due.dueOn) >= new Date(fromDateFilter);
    const matchesToDate = !toDateFilter || new Date(due.dueOn) <= new Date(toDateFilter);

    const matchesSearchTerm =
      !searchTerm ||
      due.player.toLowerCase().includes(searchTerm.toLowerCase()) ||
      due.mobile.includes(searchTerm) ||
      due.parentMobile.includes(searchTerm) ||
      (due.batch && due.batch.toLowerCase().includes(searchTerm.toLowerCase())) ||
      due.amount.toString().includes(searchTerm) ||
      (due.dueOn && due.dueOn.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (due.term && due.term.toLowerCase().includes(searchTerm.toLowerCase()));


    return (
      matchesPlayer &&
      matchesBatch &&
      matchesFromDate &&
      matchesToDate &&
      matchesSearchTerm
    );
  });

  const totalDues = Math.round(dues.reduce((acc, due) => acc + due.amount, 0));

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector('.dropdown-menu-dues');
      if (dropdown && !dropdown.contains(event.target) && !event.target.closest('.three-dots-btn')) {
        setDropdownVisible(null);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleSort = (columnKey) => {
    let direction = "asc";
    if (sortConfig.key === columnKey && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: columnKey, direction });
  };

  const sortData = (data) => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      if (sortConfig.key === 'amount') {
        const aValue = parseFloat(a[sortConfig.key]) || 0;
        const bValue = parseFloat(b[sortConfig.key]) || 0;
        return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
      }
      else if (sortConfig.key === 'dueOn' || sortConfig.key === 'startDate' || sortConfig.key === 'endDate') {
        const aDate = new Date(a[sortConfig.key]).getTime();
        const bDate = new Date(b[sortConfig.key]).getTime();
        return sortConfig.direction === "asc" ? aDate - bDate : bDate - aDate;
      }
      else {
        const aValue = String(a[sortConfig.key] || '').toLowerCase();
        const bValue = String(b[sortConfig.key] || '').toLowerCase();
        if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      }
    });
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const sortedData = sortData(filteredDues);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const totalEntries = filteredDues.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">
        {/* <div className="floating-select">
          <Select
            options={dueWithOptions}
            value={dueWithFilter}
            onChange={handleDueWithFilterChange}
            placeholder="Due With in"
            className={`sales-filter-court-booking ${dueWithFilter ? "has-value" : ""}`}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
            isClearable
          />
          {dueWithFilter && <label htmlFor="dueWithFilter">Due With in</label>}

        </div> */}
        <div className="filter-header">
          <button
            className="advanced-filter-toggle"
            onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
          >
            {showAdvancedFilters ? 'Hide Advanced Filters' : 'Show Advanced Filters'}
          </button>
        </div>

        {showAdvancedFilters && (
          <div className="advanced-filter-section" style={{ display: 'flex', gap: '40px' }}>

            <div className="floating-select" style={{ width: '50%' }}>
              <Select
                className={`sales-filter-court-booking ${playerFilter ? "has-value" : ""}`}
                classNamePrefix="react-select"
                id="playerFilter"
                options={playerOptions}
                value={playerFilter}
                onChange={handlePlayerFilterChange}
                placeholder="Player"
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  placeholder: (provided) => ({
                    ...provided,
                    color: 'black',
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {playerFilter && <label htmlFor="playerFilter">Player</label>}
            </div>

            <div className="floating-select" style={{ width: '50%' }}>
              <Select
                className={`sales-filter-court-booking ${batchFilter ? "has-value" : ""}`}
                classNamePrefix="react-select"
                id="batchFilter"
                options={batchOptions}
                value={batchFilter}
                onChange={handleBatchFilterChange}
                placeholder="Batch"
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  placeholder: (provided) => ({
                    ...provided,
                    color: 'black',
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {batchFilter && <label htmlFor="batchFilter">Batch</label>}
            </div>

          </div>
        )}



        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${fromDateFilter ? "has-value" : ""}`}
            value={fromDateFilter}
            onChange={handleFromDateChange}
            onFocus={(e) => e.target.showPicker()}
          />
          {fromDateFilter && <label htmlFor="fromDateFilter">From Date</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${toDateFilter ? "has-value" : ""}`}
            value={toDateFilter}
            onChange={handleToDateChange}
            onFocus={(e) => e.target.showPicker()}
          />
          {toDateFilter && <label htmlFor="toDateFilter">To Date</label>}
        </div>
        <div className="floating-select">
        <button className="tt-action-btn" onClick={fetchDues}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
        </button>
        </div>
      </div>


      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>

        <CSVLink
          data={filteredDues.map(({ mobile, parentMobile, ...rest }) => rest)}
          headers={headers.filter(header => header.key !== 'mobile' && header.key !== 'parentMobile')}
          filename="Dues.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>
      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="total-dues">
          <strong>Total Dues: ₹{totalDues}</strong>
        </div>
      </div>

      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredDues.length === 0 && (
        <div className="error-message">No data available</div>
      )}
      
      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}

              {hasPrivilege(userData, 'PAYMENT', 'PAYMENT_DUES_MODIFY') && (<th>Action</th>)}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((due) => (
              <tr key={due.id}>
                <td>{due.player}</td>
                <td>{due.mobile}</td>
                <td>{due.parentMobile}</td>
                <td>{due.batch}</td>
                <td>{due.amount}</td>
                <td>{new Date(due.dueOn).toLocaleDateString('en-GB')}</td>
                <td>
                  {new Date(due.startDate).toLocaleDateString()} :{' '}
                  {new Date(due.endDate).toLocaleDateString()}
                </td>
                {hasPrivilege(userData, 'PAYMENT', 'PAYMENT_DUES_MODIFY') && (
                  <td className="sales-pdf-cell">
                    <button onClick={() => handleSettlePayment(due.id)} className="pdf-button">
                      Settle Payment
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      <SettlePaymentModal
        isOpen={isModalOpen}
        onClose={closeModal}
        dueId={selectedDueId}
        academyId={Number(selectedCenter)}
        onSuccess={fetchDues}
      />
    </div>
  );
};

export default DuesList;
